export enum GoogleDrivePermissionLevel {
  Viewer = 'reader',
  Contributor = 'writer',
}
